import React from 'react';
import { Label, Toggle, useTreatmentFormAddon } from '@futurefamily/ef-components';
import { formatCurrency } from '@futurefamily/ef-utils';
import { treatments } from 'constants/treatments';

function Addons () {
  const { selectedTreatment, addOnTreatments } = useTreatmentFormAddon(treatments);

  if (!selectedTreatment) { return null; }

  return (
    <>
      {selectedTreatment.title && <div className="col-12 mt-4"><Label>{selectedTreatment.title}</Label></div>}
      <div className="col-12 mt-4">
        {addOnTreatments.map(treatment => (
          <div className="row mb-2" key={treatment.value}>
            <div className="col-10">{treatment.name} (${formatCurrency(treatment.cost)})</div>
            <div className="col-2 text-end"><Toggle name={`addons[${treatment.value}]`} /></div>
          </div>
        ))}
      </div>
    </>
  );
}

export default Addons;
